import styled from "styled-components";
import { color, ColorProps } from "styled-system";

export type SuperTextProps = ColorProps;

export const SuperText = styled.div`
  font-size: clamp(140px, 28vw, 500px);
  font-weight: 700;
  display: inline-block;
  ${color}
`;
